(ns ncr.manage.labels
  (:require
   [cljs.core.async :as async :refer-macros [go] :refer [<!]]
   [clojure.set :as set]
   [clojure.string :as str]
   [goog.functions :as gf]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [ncr.backend :as b]
   [ncr.widgets.core :as w]
   [ncr.etc.util :as u]
   [ncr.widgets.dialogs :as wd]
   [ncr.etc.alert :as a]
   [ncr.etc.modal :as m]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [ncr.manage.preferences :as preferences]
   [ncr.amplitude :as amp]
   [ncr.navigate :as n]))

(defn- label-op [operation mutation]
  (a/!operation operation
    (go
      (u/error-m [_ (<! (b/!mutation mutation))]
        (ps/pub! [:me/load])
        (ps/pub! [::load])))))

(defn- !new-label []
  (go
    (when-let
      [label (<! (wd/!input-dialog {:label "New Label"} ""))]
      (label-op
        {:operation-title "Adding Label"
         :success-title "Label Added"
         :body label}
        [:label_create {:name label} [:id]]))))

(defn- !update-label [{:keys [id] label-name :name}]
  (go
    (when-let
      [label (<! (wd/!input-dialog {:label "Label"} label-name))]
      (label-op
        {:operation-title "Updating Label"
         :success-title "Label Updated"
         :body label}
        [:label_update {:id id :name label} [:id]]))))

(defn- !delete-label [{nm :name :keys [id]}]
  (go
    (when
      (<!
        (m/!alert
          {:title "Deleting Label"
           :title-icon-variant :warning
           :actions-variant :ok-cancel
           :body
           [:span
            "Are you sure you want to delete label "
            [:b (pr-str nm)]
            "?"]}))
      (label-op
        {:operation-title "Deleting Label"
         :success-title "Label Deleted"
         :body nm}
        [:label_delete {:id id}]))))

(defn- c-toolbar []
  [pf/c-toolbar
   [pf/c-toolbar-content
    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :arrow-left
       :on-click
       (fn [_]
         (amp/navigate! {"Origin" "Manage Labels" "Destination" "<back>"})
         (n/back!))
       :tooltip "Back"}]

     [w/c-toolbar-button
      {:icon :reload
       :on-click #(ps/pub! [::load])
       :tooltip "Reload"}]]

    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :plus
       :on-click !new-label
       :tooltip "Add"}]]]])

(defn- use-labels []
  (ps/sub-reducer-map! {:status nil}
    {::set (fn [old state] state)

     ::load
     (fn [state]
       (go
         (u/if-ok
           [rv
            (<! (b/!query
                  [:me
                   [[:cluster
                     [[:labels
                       [:id :name
                        [:stats [:document :timesheet :estimate]]]]]]]]))]
           (ps/pub!
             [::set {:status :loaded :items (get-in rv [:cluster :labels])}])
           (ps/pub! [::set {:status :error :error rv}])))
       {:status :loading
        :items (:items state)})}))

(defn- c-label [{:keys [id stats] label-name :name :as label}]
  (let [{:keys [document timesheet estimate]} stats]
    [pf/c-data-list-item
     {:class :pf-m-selectable
      :on-click #(!update-label label)}
     [pf/c-data-list-item-row
      [pf/c-data-list-item-cells {}
       [pf/c-data-list-cell
        [pf/l-flex {:direction :column :space-items :space-items-xs}
         [:span (str "#" label-name)]
         [:span.pf-u-color-200
          (->>
            [(when document
               (str "Documents: " document))
             (when estimate
               (str "Estimates: " estimate))
             (when timesheet
               (str "Timesheets: " timesheet))]
            (filter some?)
            (str/join ", "))]]]]

      [pf/c-data-list-action {}
       [pf/c-dropdown-menu
        {:dropdown-items
         [[pf/c-dropdown-item
           {:icon [w/c-menu-icon {:icon :pencil-outline}]
            :on-click #(!update-label label)}
           "Edit"]
          [pf/c-dropdown-item
           {:icon [w/c-menu-icon {:icon :minus}]
            :is-disabled (or estimate timesheet)
            :on-click #(!delete-label label)}
           "Delete"]]}]]]]))


(defn c-manage-labels []
  (let
    [state (use-labels)]

    (uix/with-effect []
      (ps/pub!
        [::load true]))

    [:<>
     [pf/c-page-section {:class :pf-u-p-0 :aria-label "Toolbar"}
      [c-toolbar]]

     [pf/c-page-section
      {:class :pf-u-p-0
       :variant :light
       :has-overflow-scroll true
       :aria-label "Label list"}
      (let [{labels :items reason :error} @state]
        (cond
          reason
          [pf/c-alert
           {:class :pf-u-w-100
            :is-inline true
            :variant :danger
            :title (str "Error: " reason)}]

          (sequential? labels)
          [pf/c-data-list {:is-compact true}
           (for
             [{:keys [id] :as label}
              (sort-by :name labels)]
             ^{:key id} [c-label label])]

          :else
          [w/c-empty-progress {:class :pf-u-w-100} "Loading..."]))]]))
